import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField, Grid } from '@material-ui/core'
import { setCart } from '../../actions/actionCreators';
import DiscountCodeService from '../../services/DiscountService'
import CartService from '../../services/CartService';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiOutlinedInput-root": {
      height: '36px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    "& .MuiInputLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    },
    "& .MuiInput-input": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "inherit",
    },
    "& .MuiFormLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "0.85rem",
    },
    "& .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 12px) scale(1)",
      pointerEvents: 'none',
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    }
  },


  [theme.breakpoints.down('xs')]: {
    root: {
      "& .MuiInputLabel-root": {
        fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
        color: "black"
      },
      "& .MuiInput-input": {
        fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
        fontSize: "inherit",
      },
      "& .MuiFormLabel-root": {
        fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
        fontSize: "0.85rem",
      }
    },
  },


}));

const DiscountForm = ({ token, email }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const matches = useMediaQuery("(max-width:599px)");
  const mainColor = useSelector(state => state.frontConfigReducer.color);

  const dispatch = useDispatch();
  const cart = useSelector(state => state.cartReducer);
  const [discountCode, setDiscountCode] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [isValidating, setValidation] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const changeDiscountCode = (code) => {
    setDiscountCode(code);
    if (code.length > 5) {
      setValidation(true)
      validateDiscountCode(code, email)
    } else {
      setBtnDisabled(true);
      setInvalidCode(false);
      setErrorMessage("");
    }
  }

  const submitDiscountCode = async () => {
    let response = await DiscountCodeService.apply(discountCode, email, token);
    if (response.error == null) {
      let cartResponse = await CartService.cartData(token);
      dispatch(setCart(cartResponse));
      changeDiscountCode("");
    } 
  };

  const validateDiscountCode = async (code, email) => {
    let response = await DiscountCodeService.validate(code, email, token);
    setValidation(false);
    if (response.error == null) {
      // Code is valid — check minimum amount against cart subtotal
      if (response.minimum_amount > 0 && cart.subtotal_price < response.minimum_amount) {
        setInvalidCode(true);
        setBtnDisabled(true);
        setErrorMessage(`Minimum $${(response.minimum_amount / 100).toFixed(2)}`);
      } else {
        setBtnDisabled(false);
        setInvalidCode(false);
        setErrorMessage("");
      }
    } else {
      setInvalidCode(true);
      setBtnDisabled(true);
      const msg = response.error?.message || "";
      if (msg.includes("expired")) {
        setErrorMessage("Discount code expired");
      } else if (msg.includes("unavailable")) {
        setErrorMessage("Discount code unavailable");
      } else {
        setErrorMessage("Invalid discount code");
      }
    }
  }

  const renderHelperText = () => {
    if (isValidating) {
      return "Validating...";
    }
    if (invalidCode && discountCode.length > 5) {
      return errorMessage || "Invalid discount code";
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 1rem' }}>
      <TextField
        size="small"
        id="outlined-basic"
        label={t("Discount code")}
        variant="outlined"
        value={discountCode}
        onChange={e => changeDiscountCode(e.target.value)}
        helperText={renderHelperText()}
        style={{ width: '65%', background: "#fff" }}
        className={classes.root}
      />
      <Button
        disabled={btnDisabled}
        onClick={() => submitDiscountCode()}
        variant="contained"
        size="small"
        style={{ backgroundColor: btnDisabled ? "#E0E0E0" : mainColor, color: "#FFF", height: 36, textTransform: 'none' }}
      >
        {t("Apply")}
      </Button>
    </div>
  )
}

export default DiscountForm;

DiscountForm.defaultProps = {
  token: "SJ46Qx10BuKXH360zJ4Tc2rh5ZlK3EXQ",
  email: "andisadiazl@gmail.com"
}

//className="DiscountForm"